import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { RightShipInspectionsService } from "../../../../../../services/rightship-inspections/rightship-inspections.service";
import { UnitOfWorkItem } from "../../../../../../utilities/unit-of-work-observer";

@transient()
@autoinject
export class BookingRequestsPromptDialog {

    public loading: boolean = false;
    private _invoiceId: number;
    private _changes: { [index: string]: UnitOfWorkItem };
    private _submitToSF: boolean;
    onProceed: () => void;
    onCancel: () => void;

    constructor(private dialogClientService: DialogClientService, private notificationClientService: NotificationClientService,
        private rightshipInspectionService: RightShipInspectionsService
    ) {

    }

    activate(model: { invoiceId: number, changes: { [index: string]: UnitOfWorkItem }, submitToSF: boolean, onProceed: () => Promise<void>, onCancel: () => void })
    {
        this._invoiceId = model.invoiceId;
        this._changes = model.changes;
        this._submitToSF = model.submitToSF;
        this.onProceed = model.onProceed;
        this.onCancel = model.onCancel;
    }

    close() {
        this.dialogClientService.hide(true);
    }

    async proceed(notifyInspectors: boolean = false)
    {
        try {
            //trigger loading
            this.loading = true;

            await this.rightshipInspectionService.saveRightShipInspectionBillingDetails({ 
                id: this._invoiceId, 
                changes: this._changes,
                submitOrderToSalesforce: this._submitToSF,
                shouldNotifyInspectors: notifyInspectors
            });

            if(this.onProceed)
                this.onProceed();

            //terminate loading
            this.loading = false;

            this.notificationClientService.show("Booking requests sent successful", "Booking requests has been sent successfully to the eligible inspection companies / freelancers.", NotificationType.Success);
            
            this.notificationClientService.show("Update successful", "Inspection billing details updated successfully.", NotificationType.Success);

            //close all dialogs
            this.dialogClientService.hide(true, "default", true);
        } catch (e) {            
            //terminate loading
            this.loading = false; 
            //Add error message
            this.notificationClientService.show("Error", "Send Booking Requests Failed", NotificationType.Error);
        }
    }

    cancel()
    {
        if(this.onCancel)
            this.onCancel();

        this.close();
    }
}